module.exports = __webpack_public_path__ + "img/error404.13c423e6.png";